/*
 * @Descripttion:
 * @version:
 * @Author: shp
 * @Date: 2021-11-30 11:13:57
 * @LastEditors: shp
 * @LastEditTime: 2021-11-30 15:39:13
 */
var merge = require("webpack-merge");

module.exports = merge(
  {},
  {
    NODE_ENV: '"testing"',
    GOODWILL_HOST: "http://crmgoodwilltest.porsche-dealer-platform.com",
  },
  {
    NODE_ENV: '"testing"',
    MODIFYPASS_HOST: "http://redemption-gateway.boldseas.com",
  },
  {
    NODE_ENV: '"testing"',
    REFERRALPLATFORM_HOST: "https://referral.dev.porsche-preview.cn",
  },
  {
    NODE_ENV: '"testing"',
    GIFT_HOST: "https://pdmstest.cloudshuo.com",
  },
  {
    NODE_ENV: '"testing"',
    ETMT_HOST: "https://s8.dcpo.porsche.cn",
  },
  {
    NODE_ENV: '"testing"',
    PORSCHECLUB_HOST: "https://gate.staging.porsche-preview.cn/cm-community-service",
  },
  {
    NODE_ENV: '"testing"',
    CM_PORTAL_HOST: "https://crm-portal.dev.porsche-preview.cn/admin",
  },
  {
    NODE_ENV: '"testing"',
    SHOW_NEW_REFERRAL_TEST_ENV: true
  }
);



//////////////////
// WEBPACK FOOTER
// ./config/test.env.js
// module id = WXia
// module chunks = 5